import { type ServiceMethod } from '@/application/interfaces/service';

import { type OrderData } from '../model';

export interface Meta {
  page: number;
  perPage: number;
  totalCount: number;
  hasNextPage: boolean;
}

export interface Response {
  data: OrderData[];
  meta: Meta;
}

const getSaleOrders: ServiceMethod<Response> =
  (httpClient) => async (options) => {
    const { body } = await httpClient.get<Response, undefined, undefined>(
      `/api/v3/sale-order`,
      options
    );

    return body;
  };

export default getSaleOrders;
